import { memo } from "react";

import Dialog from "@mui/material/Dialog";

import { Finding } from "stores/FindingStore";

import FindingDetails from "components/FindingDetails";

// -----------------------------------------------------------------------------

const OrganizationFindingModal = memo(function OrganizationFindingModal({
  finding,
  onClose,
}: OrganizationFindingModalProps): JSX.Element | null {
  //
  if (!finding) {
    onClose();
    return null;
  }

  //
  return (
    <Dialog open={true} onClose={() => onClose?.(finding.uuid)} fullWidth>
      <FindingDetails finding={finding} onClose={onClose} isDashboard />
    </Dialog>
  );
});

export default OrganizationFindingModal;

// -----------------------------------------------------------------------------

interface OrganizationFindingModalProps {
  finding: Finding;
  onClose: (uuid?: string) => void;
}
